import axios from "axios";
import { getSession } from "../Utils/SessionUtils";

const api_url = process.env.REACT_APP_API;

/* Setting the header for the axios request. */
const config = {
  headers: { Authorization: `Bearer ${getSession("token")}` },
};

const currentOrg = getSession("usedorganisations");

export async function addTable(
  table_number,
  capacity,
  status,
  location,
  organisation_id,
) {
  const body = {
    table_number: table_number,
    capacity: capacity,
    status: status || "available",
    location: location || "indoor",
    organisation_id: organisation_id,
  };

  const httpHeaders = {
    headers: {
      Authorization: `Bearer ${getSession("token")}`,
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.post(api_url + "tables", body, httpHeaders);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function editTable(table_number, capacity, status, location, id) {
  const body = {
    table_number: table_number,
    capacity: capacity,
    status: status,
    location: location,
    id: id,
  };

  const httpHeaders = {
    headers: {
      Authorization: `Bearer ${getSession("token")}`,
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.patch(api_url + "tables", body, httpHeaders);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function getTablesByOrganisation(organisation_id) {
  try {
    const response = await axios.get(
      api_url + "tables/organisation/" + organisation_id,
      config,
    );
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function getTablesByStatus(status, organisation_id) {
  try {
    const response = await axios.get(
      api_url + "tables/status/" + status + "/organisation/" + organisation_id,
      config,
    );
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function getTableById(id) {
  try {
    const response = await axios.get(api_url + "tables/" + id, config);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function getAllTables(organisation_id) {
  try {
    const response = await axios.get(
      api_url + "tables/organisation/" + organisation_id,
      config,
    );
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function deleteTable(id) {
  try {
    const response = await axios.delete(api_url + "tables/" + id, config);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function updateTableStatus(id, status) {
  const body = {
    id: id,
    status: status,
  };

  const httpHeaders = {
    headers: {
      Authorization: `Bearer ${getSession("token")}`,
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.patch(api_url + "tables", body, httpHeaders);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
